import React, { Component } from 'react';
import Cookie from 'js-cookie';
import datetime from 'node-datetime';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types'


import DashboardMobileNav from '../../navigation.components/DashboardMobileNav';
import UserDashBoardSideNavigation from '../userDashBoard.components/UserDashBoardSideNavigation';
import UserDashBoardTopNavigation from '../userDashBoard.components/UserDashBoardTopNavigation';
import WithDrawInvestModal from '../../modals/WithDrawInvestModal';
import { addCommasToMoney } from '../../../helper/index';

/**
 * @class WithDrawInvestment
 */
class WithDrawInvestment extends Component {
  /**
   *
   * @returns {*} - render
   */
  render() {
    const investObj = Cookie.getJSON('investObj');
    const userAmount = investObj ? investObj.amount : '';
    const userTitle = investObj ? investObj.title : '';
    const userMaturity = investObj ? investObj.maturityDate : '';
    const mainAmount = addCommasToMoney(userAmount);
    const { history } = this.props;

    const withDrawInvestment = (
      <section className="body_space">
        <div className="go_back">
          <span onClick={history.goBack}>
            <i className="fa fa-arrow-left" aria-hidden="true" />
            {' '}
            {'  '}
             Go Back
          </span>
        </div>
        <div className="savings_options_detail_title mb-5">
          <div className="title_trxt">
            <h4>
              {userTitle === 'fixTip' ? 'Fixed Term Investment Portfolio' : 'Meristem Treasury Linked Portfolio'}
            </h4>
            <p className="my-2">
              <span> Date Created </span>
              {' '}
              { datetime.create(investObj ? investObj.dateCreated : '').format('m/d/y') }
            </p>
          </div>

          <div className="ml-auto mr-5 inv_delete_btn">
            <button type="button" data-toggle="modal" data-target="#meep_settings">
              <span style={{ color: 'white' }}>Withdraw</span>
            </button>
          </div>

        </div>

        <div className="invv">
          <div>

            <span>
            Total Investment
            </span>
            <p>
              {`₦${mainAmount}`}
            </p>

          </div>
          <div>
            <span>
             Investment Tenor
            </span>
            <p>
             9 Months
            </p>
          </div>
          <div>
            <span>
            Maturity Date
            </span>
            <p>
              { datetime.create(userMaturity).format('m/d/y') }
            </p>
          </div>
          <div>
            <span>
                 Status
            </span>
            <p>
              {investObj ? investObj.status : ''}
            </p>
          </div>

        </div>
      </section>
    );
    return (
      <>
        <DashboardMobileNav />
        <UserDashBoardSideNavigation />
        <div className="main_body_wrapper">
          <UserDashBoardTopNavigation />
          { withDrawInvestment }
        </div>
        <WithDrawInvestModal />
      </>
    );
  }
}

WithDrawInvestment.propTypes = {
  history: PropTypes.shape({}),
};

export default withRouter(WithDrawInvestment);
